import axios from 'axios'
import { DocusignAccount } from '../types/docusignUser'

export function createDocusignRequest(defaultAccount: DocusignAccount | null) {
  if (!defaultAccount) {
    return axios.create()
  }

  const baseUri = process.env.REACT_APP_ENV === 'production' ? defaultAccount?.base_uri : process.env.REACT_APP_URL

  const instance = axios.create({
    baseURL: `${baseUri}/restapi/v2.1/accounts/${defaultAccount?.account_id}`,
  })

  instance.interceptors.request.use((config) => {
    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const token = localStorage.getItem('DOCUSIGN_ACCESS_TOKEN')

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  })

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (!error.response) {
        return Promise.reject(error)
      }

      const { status } = error.response

      if (status >= 500) {
        console.log(error.response.data.message || 'Something went wrong.')
      }

      if (status === 401) {
        localStorage.removeItem('DOCUSIGN_ACCESS_TOKEN')
      }

      return Promise.reject(error)
    },
  )

  return instance
}
